// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of support (D19, U6). Object scope comes on top: the grants of the organisation and engagement. */
export const supportPermissions = definePermissions('support', {
  read: 'View tickets, their messages and the quarantine',
  create: 'Make tickets, also by hand for a call or Teams message',
  update: 'Change, assign, answer and close tickets; notes and drafts',
  delete: 'Delete a ticket that was made by mistake',
  export: 'Export tickets',
  approve: 'Approve the mail that answers a ticket',
});
